module.exports = __webpack_public_path__ + "static/media/Ｖ_003.46b96039.jpg";